/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ReportType = {
  Base: "BASE",
  Sub: "SUB",
  Error: "ERROR",
  Warning: "WARNING",
  Info: "INFO",
} as const;

export type ReportType = (typeof ReportType)[keyof typeof ReportType];

export type ReportTypeEnumType = typeof ReportType;
export type ReportTypeOptional = ReportType;
export type ReportTypeTrackedI = ReportType;
export type ReportTypeTracked = ReportType;
export type ReportTypeMetaI = EnumMetaType<ReportTypeEnumType, ReportType>;
export const ReportTypeMeta = typeMetaEnum<ReportTypeEnumType, ReportType>(
  "ReportType",
  ReportType,
);
export function transformDatesReportType(model: ReportType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
